'use client';

import {useEffect, useState} from 'react';

const ONE_SECOND = 1000;
const MS_PER_MIN = ONE_SECOND * 60;
const MS_PER_HOUR = MS_PER_MIN * 60;
const MS_PER_DAY = MS_PER_HOUR * 24;

type Props = {
  until: string;
  onExpired?: () => void;
};

export function Countdown({until, onExpired}: Props) {
  const [timer, setTimer] = useState('');

  useEffect(() => {
    const id = setInterval(() => {
      const diff = new Date(until).getTime() - Date.now();
      if (diff <= 0) {
        setTimer('expired!');
        clearInterval(id);
        onExpired?.();
        return;
      }
      const days = Math.floor(diff / MS_PER_DAY);
      const hours = Math.floor((diff % MS_PER_DAY) / MS_PER_HOUR);
      const minutes = Math.floor((diff % MS_PER_HOUR) / MS_PER_MIN);
      const seconds = Math.floor((diff % MS_PER_MIN) / ONE_SECOND);

      const pad = (n: number) => String(n).padStart(2, '0');
      const parts = [
        ...(days > 0 ? [`${days}d`] : []),
        `${pad(hours)}h`,
        `${pad(minutes)}m`,
        `${pad(seconds)}s`,
      ];
      setTimer(parts.join(' : '));
    }, ONE_SECOND);
    return () => clearInterval(id);
  }, [until]);

  return <>{timer || '...'}</>;
}
